export default function translate(i18n, propriete) {
  if (propriete === 'nom') {
    return i18n.t('addEditPays.error.nom');
  }
  if (propriete === 'normeIso') {
    return i18n.t('addEditPays.error.normeISO');
  }
  if (propriete === 'normePtt') {
    return i18n.t('addEditPays.error.normePTT');
  }
  return propriete;
}
